import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-mq",
  "use": "icon-icon-mq-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-icon-mq\">\n  <path fill=\"#fff\" d=\"M0 0h512v512H0z\" />\n  <path fill=\"#002654\" d=\"M0 0h170.7v512H0z\" />\n  <path fill=\"#ce1126\" d=\"M341.3 0H512v512H341.3z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol